module.exports = __webpack_public_path__ + "static/media/print-2.67f38d9c.jpg";